export function timestampToText(timestamp, isHideTime) {
    if (!timestamp) return 'Без выбора даты и время'
    const date = new Date(timestamp * 1000);
    const dateStr = date.toLocaleDateString(
        'ru',
        {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    const timeStr = date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
    return isHideTime
        ? `${dateStr}`
        : `${dateStr}, ${timeStr}`;
}
